<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import SidebarAnnouncementsPanel from './SidebarAnnouncementsPanel.vue';

const store = useStore();
const showPanel = ref(false);

const unreadCount = computed(() => {
  const count = store.getters['platformAnnouncements/getUnreadCount'];
  if (!count) return '';
  return count < 100 ? `${count}` : '99+';
});

function togglePanel() {
  showPanel.value = !showPanel.value;
}

function closePanel() {
  showPanel.value = false;
}
</script>

<template>
  <div class="relative">
    <button
      class="size-8 rounded-lg hover:bg-n-alpha-1 flex-shrink-0 grid place-content-center relative"
      :title="$t('PLATFORM_ANNOUNCEMENTS.BELL_TOOLTIP')"
      @click="togglePanel"
    >
      <span class="i-lucide-megaphone size-4" />
      <span
        v-if="unreadCount"
        class="min-h-2.5 min-w-2.5 p-0.5 px-1 bg-n-ruby-9 rounded-lg absolute -top-1 -right-1.5 grid place-items-center text-[10px] leading-none text-white"
      >
        {{ unreadCount }}
      </span>
    </button>
    <SidebarAnnouncementsPanel
      v-if="showPanel"
      @close="closePanel"
    />
  </div>
</template>
